// Below this width the layout switches to its phone arrangement
export const NARROW_WIDTH = 640;
export const NARROW = `@media (max-width: ${NARROW_WIDTH}px)`;
